import {createContext, ReactNode, useState} from "react";
import { ReportDatatype } from "@/types/ReportRun";
import { RunConfigDefaults } from "@/types/ApiTypes";

export type DefaultConfigValue = NonNullable<RunConfigDefaults>;

export type DefaultConfigWizardState = {
    enableDemographics?: boolean;
    enableMarketTypePicker?: boolean;
    requiredMasterCompany?: string;
    requiredMarketGroup?: string;
    showRemainingMarkets?: boolean;
}

export type DefaultConfigWizardContextValue = {
    value: NonNullable<DefaultConfigValue>;
    state?: DefaultConfigWizardState;
    onChange?: (name: keyof DefaultConfigValue, value: any, data?: any) => void;
    selectedDataset: ReportDatatype;
    hasChanges?: boolean;
}

export const DefaultConfigWizardContext = createContext<DefaultConfigWizardContextValue>({
    value: {} as any,
    selectedDataset: 'rms' as ReportDatatype
});
DefaultConfigWizardContext.displayName = 'DefaultConfigWizardContext'
